import React from 'react';
import ListPage from '../../base/ListPage.js';
import APILXD from '../../../http/APILXD.js';
import {Modal, message, Popover, Button, Image, Tag} from 'antd';
import TimeHelp from "../../../tool/TimeHelp";
import HttpTool from "../../../tool/HttpTool";
import styles from "./index.less";
import ModalBase from "../../../components/modalBase";
import UploadFile from "../../../components/upLoad/UploadFile";
import dayjs from "dayjs";
import ModalDelete from "../../../components/modalDelete/ModalDelete";

//头像，名称，时间，商品名称，评分(0-5)，评论内容，评论类型(下拉)

const MB = new ModalBase()
const MD = new ModalDelete()
const CommentTypeMap = {
  'positionHomepage': '职业-首页评论',
  'positionDetail': '职业-介绍页评论',
  'capHomepage': '技能-首页评论',
  'capDetail': '技能-介绍页评论',
  // 'containerDetail': '容器-介绍页评论',
}

export default class CommentList extends ListPage {
  constructor(props) {
    super(props);
  }

  base_getListConfig() {
    return {
      table: {
        columns: this.getTableColumns(),
        url: APILXD.getConfCommentList,
        otherParam: null,
        couldSelect: true,
        option: {
          rowKey: '_id',
        }
      },
      new: {
        defaultValue: '新增评论',
        action: () => {
          this.add();
        }
      },
      search: {
        seniorSearch: this.getSeniorSearch(),
        option: {
          openSenior: true,
          placeholder: '请输入评论内容搜索',
          reg: /^[\s\S]*$/,
          beforeSubmit: (value) => {
            if (value.keyword) {
              value.content = value.keyword
            }
            delete value.keyword
            value.commodityId = value.capSel || value.positionSel

            return true;
          },
        }
      },
      extraBox: ()=>{
        return <div style={{float:"left"}}>
          <Button
            type={"primary"}
            danger={true}
            style={{marginLeft: "20px"}}
            disabled={!(this.state.selectedRowKeys && this.state.selectedRowKeys.length)}
            onClick={()=>{
              console.log(this.state.selectedRowKeys)
              MD.show({
                  title: "提示",
                  okTitle: "确定",
                  closeTitle: "取消",
                },
                {}
                ,
                {
                  otherParam: {_ids: this.state.selectedRowKeys},
                  content: `勾选的${this.state.selectedRowKeys.length}个评论`,
                  url: APILXD.delConfComment,
                  apiType: 'post',
                  callBack: (state) => {
                    //删除成功回调
                    if(state === "success"){

                      if(this.items?.length === 1 && this.state.page > 1){
                        //当前页的最后一条
                        this.setState({
                          page: this.state.page - 1
                        },()=>{
                          this._loadDataForNet();
                        })
                      }else{
                        this._loadDataForNet();
                      }

                      this.setState({
                        selectedRowKeys: [],
                      })
                    }
                  }
                });
            }}
          >
            批量删除
          </Button>
        </div>
      }
    }
  }

  getSeniorSearch() {
    return {
      colCount: 3,
      formItemLayout: {
        labelCol: {span: 6},
        wrapperCol: {span: 18, offset: 0},
      },
      parameterArr: [
        {
          field: "status",
          name: "状态",
          type: 'select',
          selectType: 'value',
          reg: (v) => {
            return true;
          },
          option: {
            allowClear: true,
          },
          data: [
            {
              title: '已上线',
              value: 'online',
            },
            {
              title: '已下线',
              value: 'offline',
            },
          ]
        },
        {
          field: "commentType",
          name: "评论类型",
          type: 'Select',
          selectType: 'value',
          reg: (v)=>{
            return !!v
          },
          option: {
            allowClear: true,
          },
          data: Object.keys(CommentTypeMap).map((key)=>{
            return {
              title: CommentTypeMap[key],
              value: key
            }
          }),
          onChange: (value, state, changeState)=>{
            console.log(value);
            let newArr = state.parameterArr;
            newArr.forEach((obj) => {
              //  'positionHomepage': '职业-首页评论',
              //   'positionDetail': '职业-介绍页评论',
              //   'capHomepage': '技能-首页评论',
              //   'capDetail': '技能-介绍页评论',
              if (obj.mark === 'positionSel') {
                obj.field = ['positionHomepage','positionDetail'].includes(value) ? obj.mark : null;
              }
              if (obj.mark === 'capSel') {
                obj.field = ['capHomepage','capDetail'].includes(value) ? obj.mark : null;
              }
            });
            changeState('parameterArr', newArr);
          }
        },
        {
          mark: "positionSel",
          field: null,
          name: "商品",
          type: 'Select',
          selectType: 'value',
          verMessage: "请选择要评论的商品",
          reg: (v)=>{
            return !!v
          },
          option: {
            showSearch: true,
            onSearch: () => { },
            filterOption: (input, option) => {
              return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            optionFilterProp: "children",
          },
          apiConfig: {
            url: APILXD.getPersonagePositionSimplifiedList,
            fillObject: (json) => {
              let data = [];
              for (let obj of json) {
                data.push({
                  title: obj.name,
                  value: obj._id,
                });
              }
              return data;
            }
          }
        },
        {
          mark: "capSel",
          name: "商品",
          type: 'Select',
          selectType: 'value',
          verMessage: "请选择要评论的商品",
          reg: (v)=>{
            return !!v
          },
          option: {
            showSearch: true,
            onSearch: () => { },
            filterOption: (input, option) => {
              return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            optionFilterProp: "children",
          },
          apiConfig: {
            url: APILXD.getPersonageCapSimplifiedList,
            fillObject: (json) => {
              let data = [];
              for (let obj of json) {
                data.push({
                  title: obj.commodityName,
                  value: obj._id,
                });
              }
              return data;
            }
          }
        },
      ],
    }
  }

  getAddData(defaultData) {
    let defaultOption = {
      type: "input",
      ver: true,
      reg: /^[\S\s]{0,50}$/,
      verMessage: "请填写，最多50个字符",
      required: true,
    };
    let props = {
      colCount: 1,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 16, offset: 0 },
      },
      parameterArr: [
        {
          ...defaultOption,
          field: "commentType",
          name: "评论类型",
          type: 'Select',
          selectType: 'value',
          reg: (v)=>{
            return !!v
          },
          verMessage: "请选择评论类型",
          option: {
            disabled: !!defaultData,
            defaultValue: defaultData?.commentType?{
              key: defaultData.commentType,
              value: defaultData.commentType,
            }:null
          },
          data: Object.keys(CommentTypeMap).map((key)=>{
            return {
              title: CommentTypeMap[key],
              value: key
            }
          }),
          onChange: (value, state, changeState)=>{
            console.log(value);
            let newArr = state.parameterArr;
            newArr.forEach((obj) => {
              //  'positionHomepage': '职业-首页评论',
              //   'positionDetail': '职业-介绍页评论',
              //   'capHomepage': '技能-首页评论',
              //   'capDetail': '技能-介绍页评论',
              if (obj.mark === 'positionSel') {
                obj.field = ['positionHomepage','positionDetail'].includes(value) ? obj.mark : null;
              }
              if (obj.mark === 'capSel') {
                obj.field = ['capHomepage','capDetail'].includes(value) ? obj.mark : null;
              }
            });
            changeState('parameterArr', newArr);
          }
        },
        {
          ...defaultOption,
          field: "userName",
          name: "用户名称",
          type: 'input',
          reg: /^[\S\s]{1,20}$/,
          verMessage: "请填写，最多20个字符",
          option: {
            maxLength: "20",
            defaultValue: defaultData?.userName
          }
        },
        {
          ...defaultOption,
          field: "userTags",
          name: "用户标签",
          type: 'SelectAll',
          selectType: 'value',
          reg: (v) => {
            if(!v?.length){
              return false
            }

            return !(v.some((item) => {return item.length>10}))
          },
          verMessage: "请配置用户标签，且每个标签最多使用10个字符",
          option: {
            mode: "tags",
            defaultValue: defaultData?.userTags?.length? defaultData?.userTags.map((str)=>{
              return {
                key: str,
                value: str
              }
            }):[]
          }
        },
        {
          ...defaultOption,
          field: "userImageUrlSet",
          name: "用户头像",
          type: 'diy',
          component: UploadFile,
          reg: (v)=>{
            return v?.length
          },
          verMessage: "请上传头像",
          option: {
            size: 1,
            accept: "image/*",
            defaultValue: defaultData?.userImageUrl ? [{
              url: defaultData?.userImageUrl
            }] : null
          }
        },
        {
          ...defaultOption,
          mark: "positionSel",
          field: (defaultData && ['positionHomepage','positionDetail'].includes(defaultData.commentType)) ?'positionSel':null,
          name: "商品",
          type: 'Select',
          selectType: 'value',
          verMessage: "请选择要评论的商品",
          reg: (v)=>{
            return !!v
          },
          option: {
            disabled: !!defaultData,
            showSearch: true,
            onSearch: () => { },
            filterOption: (input, option) => {
              return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            optionFilterProp: "children",
            defaultValue: defaultData?.commodityId? {
              key: defaultData.commodityId,
              value: defaultData.commodityId
            }: undefined
          },
          apiConfig: {
            url: APILXD.getPersonagePositionSimplifiedList,
            fillObject: (json) => {
              let data = [];
              for (let obj of json) {
                data.push({
                  title: obj.name,
                  value: obj._id,
                });
              }
              return data;
            }
          }
        },
        {
          ...defaultOption,
          mark: "capSel",
          field: (defaultData && ['capHomepage','capDetail'].includes(defaultData.commentType)) ?'capSel':null,
          name: "商品",
          type: 'Select',
          selectType: 'value',
          verMessage: "请选择要评论的商品",
          reg: (v)=>{
            return !!v
          },
          option: {
            disabled: !!defaultData,
            showSearch: true,
            onSearch: () => { },
            filterOption: (input, option) => {
              return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            optionFilterProp: "children",
            defaultValue: defaultData?.commodityId? {
              key: defaultData.commodityId,
              value: defaultData.commodityId
            }: undefined
          },
          apiConfig: {
            url: APILXD.getPersonageCapSimplifiedList,
            fillObject: (json) => {
              let data = [];
              for (let obj of json) {
                data.push({
                  title: obj.commodityName,
                  value: obj._id,
                });
              }
              return data;
            }
          }
        },
        {
          ...defaultOption,
          field: "score",
          name: "评分",
          type: 'Rate',
          verMessage: "请选择评分",
          reg: (v)=>{
            return v === 0 || !!v
          },
          option: {
            allowClear: true,
            allowHalf: true,
            defaultValue: defaultData?.score
          }
        },
        {
          ...defaultOption,
          field: "content",
          name: "评论内容",
          type: 'TextArea',
          reg: /^[\S\s]{1,1000}$/,
          verMessage: "请填写，最多1000个字符",
          option: {
            placeholder: "可以填写html片段代码",
            maxLength: "1000",
            defaultValue: defaultData?.content
          },
          extra: '例：这里<span style="color: #299bff">蓝色文字</span>，这里<span style="font-weight: bold">粗体</span>, 这里<span style="font-size: 24px">字体大</span>。'
        },
        {
          ...defaultOption,
          field: "commentTimeSet",
          name: "评论时间",
          type: 'DatePicker',
          reg: (v)=>{
            return !!v
          },
          verMessage: "请选择时间",
          option: {
            style: {width: "100%"},
            showTime: true,
            disabledDate: (value) => {
              if (!value) {
                return false;
              }
              let nowDate = new Date();
              return value.valueOf() > nowDate.valueOf() - 86400000;
            },
            defaultValue: defaultData?.commentTime?dayjs(defaultData?.commentTime):null
          }
        },
      ],
    };
    return {
      props,
      otherParam: null
    }
  }

  add(defaultValue) {
    let addData = this.getAddData(defaultValue);
    MB.show(
      {
        title: defaultValue?"编辑评论":"新增评论",
        okTitle: "确定",
        closeTitle: "取消",
      },
      addData.props
      ,
      {
        otherParam: defaultValue?{
          _id: defaultValue._id
        }:{},
        url: defaultValue?APILXD.updateConfComment:APILXD.addConfComment,
        beforeSubmit: (param) => {
          if(param.userImageUrlSet?.length){
            param.userImageUrl = param.userImageUrlSet[0].url
          }
          if(param.commentTimeSet){
            param.commentTime = param.commentTimeSet.valueOf()
          }
          if(param.userTags){
            param.userTags = param.userTags.map((item)=>{
              return typeof item === 'object'?item.value : item
            })
          }
          param.commodityId = param.capSel || param.positionSel

          return true;
        },
        callBack: (state, msg) => {
          //添加成功回调
          state == 'success' && this._loadDataForNet();
        }
      });
  }

  /**
   *  列表数据配置
   */
  getTableColumns() {
    return [
      {
        title: '评论类型',
        dataIndex: 'commentType',
        key: 'commentType',
        render: (v) => {
          return CommentTypeMap[v]
        }
      }, {
        title: '用户头像',
        dataIndex: 'userImageUrl',
        key: 'userImageUrl',
        render: (text) => {
          return <Image
            width={60}
            src={text}
          />
        }
      },
      {
        title: '用户名称',
        width: 120,
        dataIndex: 'userName',
        key: 'userName',
      },
      {
        title: '用户标签',
        dataIndex: 'userTags',
        key: 'userTags',
        render: (text) => {
          return <div style={{maxWidth: '350px'}}>
            {
              text?.map((str)=>{
                return <Tag key={str}>{str}</Tag>
              }) || '-'
            }
          </div>
        }
      },
      {
        title: '评论时间',
        dataIndex: 'commentTime',
        key: 'commentTime',
        render: (text) => {
          let time = TimeHelp.getYMDHM(text);
          return <div>{time}</div>
        }
      },
      {
        title: '商品名称',
        dataIndex: 'commodityName',
        key: 'commodityName',
      },
      {
        title: '评分',
        dataIndex: 'score',
        key: 'score',
      },
      {
        title: '评论内容',
        dataIndex: 'content',
        key: 'content',
        width: 250,
        render: (text, record, index) => {
          return <div
            dangerouslySetInnerHTML={{__html: text}}
            style={{maxHeight: "200px", overflow: "auto"}}
          >
          </div>
        },
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        render: (text) => {
          return text === 'online' ? <span style={{color: 'dodgerblue'}}>已上线</span> :
            <span style={{color: 'darkorange'}}>已下线</span>
        }
      },
      {
        title: '创建时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text) => {
          let time = TimeHelp.getYMDHM(text);
          return <div>{time}</div>
        }
      },
      {
        title: '操作',
        width: 220,
        render: (text, record, index) => {
          return (
            <div>
              {
                this.powerConfig.Edit
                  ? (record.status === 'online' ? <span onClick={() => {
                      this.changeState(record._id, 'offline')
                    }} style={{color: "darkorange"}} className={styles.btnCopy}>{"下线评论"}</span> :
                    <span onClick={() => {
                      this.changeState(record._id, 'online')
                    }} style={{color: "dodgerblue"}} className={styles.btnEdit}>{"上线评论"}</span>)
                  : null
              }
              {
                this.powerConfig.Edit
                  ?  <span onClick={() => {
                    this.add(record)
                  }} className={styles.btnEdit}>{"修改"}</span>
                  : null
              }
              {
                this.powerConfig.Delete && record.status === 'offline'
                  ?  <span onClick={() => {
                    MD.show({
                        title: "提示",
                        okTitle: "确定",
                        closeTitle: "取消",
                      },
                      {}
                      ,
                      {
                        otherParam: {_ids: [record._id]},
                        content: record.userName + '的评论',
                        url: APILXD.delConfComment,
                        apiType: 'post',
                        callBack: (state) => {
                          //删除成功回调
                          if(state === "success"){
                            if(this.items?.length === 1 && this.state.page > 1){
                              //当前页的最后一条
                              this.setState({
                                page: this.state.page - 1
                              },()=>{
                                this._loadDataForNet();
                              })
                            }else{
                              this._loadDataForNet();
                            }
                          }
                        }
                      });
                  }} className={styles.btnDelete}>{"删除"}</span>
                  : null
              }
            </div>
          )
        }
      },
    ]
  }

  changeState(id, status) {
    Modal.confirm({
      title: '提示',
      content: "确定" + (status === 'online' ? "上线" : "下线") + "该评论吗？",
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        let param = {
          _id: id,
          status,
        };
        let successCB = (code, msg, json, option) => {
          this.setState({loading: false}, () => {
            message.success('操作成功');
            this._loadDataForNet();
          });
        };
        let failureCB = (code, msg) => {
          this.setState({loading: false}, () => {
            message.error(msg);
          });
        };

        this.setState({loading: true});

        HttpTool.post(APILXD.updateConfCommentStatus, successCB, failureCB, param);
      }
    })
  }
}